export default __webpack_public_path__ + "static/room_w.0c902a1bc3ce2c172901a037bdb79b30.png";